import {ref, unRef, shallowRef, computed, onMounted} from 'vue'

function secondsToTime(e){
    const m = Math.floor(e / 60).toString().padStart(2,'0'),
          s = Math.floor(e % 60).toString().padStart(2,'0');
    
    return `${m}:${s}`
}

export default function useTimer(data) {

    const tm = ref({
        expires: -1,
        expires_start: -1,
        timer_leave: 0,
        timer: null,
        attempt: 0,
    })

    const start_timer = (expires, attempt=1)=>{
        let tmset = tm.value
        tmset.expires = expires
        tmset.expires_start = Date.now()
        tmset.attempt = attempt
        tick_timer()
    }
    const stop_timer = () => {
        if (tm.value.timer) {
            clearTimeout(tm.value.timer)
        }
        tm.value = {
            expires: -1,
            expires_start: -1,
            timer_leave: 0,
            timer: null,
            attempt: 0,
        }
    }
    const attempt_timer = (attempt) => {
        let tmset = tm.value
        tmset.attempt = attempt
        if (0 == attempt) {
            stop_timer()
        }
    }
    const tick_timer = () => {
        let now = Date.now()
        let tmset = tm.value
        const timer_leave = tmset.expires_start + tmset.expires * 1000 - now
        if (timer_leave <= 0) {
            stop_timer()
        } else {
            tmset.timer_leave = timer_leave
            tmset.timer = setTimeout( tick_timer, 1000)
        }
    }

    const is = computed( () => tm.value.timer_leave>0 ? true : false  )

    const leave_min = computed( () => {
        return secondsToTime( tm.value.timer_leave / 1000 )
    })

    return {
        start_timer, stop_timer, attempt_timer, tick_timer, leave_min, is,
    }
}
